var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVariationMed = function SvgVariationMed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.4 14.635c-.926-.442-1.812-1.224-2.691-2.362A1 1 0 0 1 4.29 11.05c.763.988 1.422 1.518 1.971 1.781.526.251.998.281 1.468.176.499-.112 1.032-.385 1.629-.802.568-.398 1.134-.882 1.75-1.408l.096-.083c.635-.542 1.322-1.124 2.04-1.6s1.526-.885 2.419-1.039c1.918-.33 3.771.574 5.627 2.975a1 1 0 0 1-1.582 1.223c-1.622-2.098-2.811-2.381-3.706-2.227-.513.088-1.055.34-1.654.736-.6.398-1.199.901-1.844 1.453l-.12.102c-.593.507-1.23 1.051-1.88 1.507-.697.487-1.477.921-2.337 1.114-.888.2-1.82.131-2.768-.323Z",
    clipRule: "evenodd"
  })));
};

export default SvgVariationMed;